// Defoalt is for SECONDARY SCHOOLS API
export const environment = {
  // baseUrl: 'https://api.ebill.so:3355/api',
  // url: 'https://api.ebill.so:3355/',
  baseUrl: 'https://api.ebill.so:3356/api',
  url: 'https://api.ebill.so:3356/',
  production: true
};